module.exports = __webpack_public_path__ + "img/confSuccess.6b9fe639.png";